// extracted by mini-css-extract-plugin
export var content = "layout-coding-module--content--M6aDm";
export var root = "layout-coding-module--root--l4bHW";